<template>

  <ob-dialog :heading="$t('assets.new')" @ok="ok()" @cancel="close()">
    <asset-form-core :asset="asset"></asset-form-core>
  </ob-dialog>

</template>

<script>
  import AssetFormCore from './asset-form-core'
  import ObDialog from '../../shared/components/dialog'

  export default {
    name: 'create-asset-dialog',

    data () {
      return {
        asset: {}
      }
    },

    methods: {
      ok () {
        this.$emit('submit', this.asset)
      },

      close () {
        this.$emit('submit', false)
      },
    },

    components: {
      ObDialog,
      AssetFormCore
    }
  }
</script>

<style scoped lang="scss">

</style>
